<template>
  <div v-if="visible && (loading || failed || opinions.length)" class="opinion-shortcuts">
    <el-select v-if="!failed" v-model="selected" class="opinion-select" placeholder="选择常用意见，自动填入" :loading="loading" :disabled="disabled || loading" filterable clearable @change="select">
      <el-option v-for="opinion in opinions" :key="opinion" :label="opinion" :value="opinion" :title="opinion" />
    </el-select>
    <div v-else class="opinion-shortcuts-hint">常用意见暂未加载，可直接输入 <el-button type="text" size="mini" :disabled="disabled" @click="load">重试</el-button></div>
  </div>
</template>

<script>
import { myCommonOpinions } from '@/api/crm/approvalOpinion'
import { getToken } from '@/utils/auth'

export default {
  name: 'ApprovalOpinionShortcuts',
  props: {
    visible: Boolean, operationType: Number, approvalType: Number, disabled: Boolean,
    maxLength: { type: Number, default: 500 }
  },
  data: () => ({ opinions: [], loading: false, failed: false, requestId: 0, sessionToken: '', selected: '' }),
  computed: { queryKey() { return `${this.visible}:${this.operationType}:${this.approvalType}` } },
  watch: { queryKey: { immediate: true, handler() { this.load() } } },
  beforeDestroy() { this.requestId++ },
  methods: {
    async load() {
      const requestId = ++this.requestId
      const token = getToken()
      this.selected = ''; this.opinions = []; this.failed = false; this.loading = false; this.sessionToken = ''
      if (!this.visible || ![1, 2].includes(this.operationType) || !this.approvalType || !token) return
      this.loading = true
      try {
        const response = await myCommonOpinions(this.operationType, this.approvalType)
        if (requestId !== this.requestId || token !== getToken()) return
        this.opinions = (Array.isArray(response.data) ? response.data : []).filter(v => typeof v === 'string' && v.trim() && v.length <= this.maxLength)
        this.sessionToken = token
      } catch (_) {
        if (requestId === this.requestId && token === getToken()) this.failed = true
      } finally { if (requestId === this.requestId) this.loading = false }
    },
    select(opinion) {
      this.selected = ''
      if (!this.visible || this.disabled || !this.opinions.includes(opinion)) return
      if (this.sessionToken !== getToken()) { this.load(); return }
      this.$emit('select', opinion)
    }
  }
}
</script>

<style scoped>
.opinion-shortcuts { margin-bottom: 12px; line-height: 1.5; }
.opinion-select { width: 100%; }
.opinion-select /deep/ .el-input__inner { background: #f6f8fc; font-size: 13px; }
.opinion-shortcuts-hint { color: #8795a8; font-size: 12px; }
</style>
